import { createContext } from 'react';

export type FristenContextType = {
  openCreateSheet: boolean;
  setOpenCreateSheet: (open: boolean) => void;
  createSheetDefaultValues: {
    fristdatum: string | undefined;
    grund: string;
    erinnerungsZeit: string[];
  };
  setCreateSheetDefaultValues: (values: {
    fristdatum: string | undefined;
    grund: string;
    erinnerungsZeit: string[];
  }) => void;
  openEditSheet: boolean;
  setOpenEditSheet: (open: boolean) => void;
  openDeleteDialog: boolean;
  setOpenDeleteDialog: (open: boolean) => void;
  fristIndex: number;
  setFristIndex: (index: number) => void;
};

export const FristenContext = createContext<FristenContextType | null>(null);
